document.addEventListener("DOMContentLoaded", function () {
  const accTitles = document.querySelectorAll(".accordion-Title-main");

  accTitles.forEach((title) => {
    title.addEventListener("click", function () {
      const parent = this.parentNode;
      const content = parent.querySelector(".accordion-content-main");

      // If already open → close it
      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
        content.style.height = "0px";
        return;
      }

      // Close others
      document.querySelectorAll(".acc_wrap-main").forEach((item) => {
        if (item !== parent) {
          item.classList.remove("active");
          item.querySelector(".accordion-content-main").style.height = "0px";
        }
      });

      // Open current → add extra 30px
      parent.classList.add("active");
      content.style.height = `${content.scrollHeight + 30}px`;
    });
  });
});
